import React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import { addNotificationAction } from '../../action/notifications/notifications';

import * as Api from '../../api/api';

import { downloadBlob } from '../../util/download-blob';
import { ICON_NAMES, MaterialDesignIcon } from '../../util/material-design-icons';

type EmployeeDirectoryImportDownloadFileType = {
  employeeDirectoryImportId: number;
  originalFileName: string;
};

type InputProps = {
  employeeDirectoryImport: EmployeeDirectoryImportDownloadFileType;
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    addNotification: (settings: { key: string; message: string }) =>
      dispatch(addNotificationAction(settings)),
  },
});

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & DispatchProps;

export const EmployeeDirectoryImportDownloadFileButton = connect(
  null,
  mapDispatchToProps,
)(({ employeeDirectoryImport, actions }: Props) => {
  const handleDownloadClick = (empImport: EmployeeDirectoryImportDownloadFileType) => () => {
    Api.get(
      `/employee-directory-import/${empImport.employeeDirectoryImportId}/presigned-download-url`,
    )
      .then((resp) => {
        resp.json().then((json: { url: string }) => {
          downloadBlob({ filename: empImport.originalFileName, uri: json.url });
        });
      })
      .catch(() =>
        actions.addNotification({
          key: `update-employee-list-${empImport.employeeDirectoryImportId}`,
          message: 'Something went wrong while attempting to download directory list.',
        }),
      );
  };

  return (
    <Tooltip title="Download File">
      <IconButton onClick={handleDownloadClick(employeeDirectoryImport)}>
        <MaterialDesignIcon iconName={ICON_NAMES.DOWNLOAD} />
      </IconButton>
    </Tooltip>
  );
});
